import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FormTitle = styled.p`
  font-family: BiotifMedium;
  color: #1c1b3a;
  font-size: 22px;
  margin: 0;
  text-align: center;
`;

export const CloseIcon = styled.img`
  height: auto;
  width: 14px;
  cursor: pointer;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  background-color: #fff;
  gap: 15px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 235px;
  gap: 10px;
  padding: 20px;
  background-color: #fff;
  border-radius: 15px;
`;

export const BottomContainer = styled.div`
  padding: 5px;
  margin-top: 35px;
  button {
    float: right;
  }
`;
